module.exports = __webpack_public_path__ + "static/img/ios4.d3c74f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ios4.jpg
// module id = otm1
// module chunks = 1